import Box from '@mui/material/Box';
import type React from 'react';

export const ScrollableDatagrid = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ width: '100%', overflowX: 'auto' }}>{children}</Box>
);
